import { gql } from '@apollo/client';

export default class AccountingSettingsQuery {
    static GET_CUSTOMER_BANKING_SETTINGS_LIST = gql`
        query getCustomerBankingSettings($isRepoRefund: Boolean, $isPaymentRefund: Boolean, $isCPIRefund: Boolean){
            getCustomerBankingSettings(isRepoRefund: $isRepoRefund, isPaymentRefund: $isPaymentRefund, isCPIRefund: $isCPIRefund) {
                customers {
                    customerCode
                    customerName
                    address
                    accountNumber
                    customerRefundAmount
                }
                mapSetting {
                    accountId
                    accountDescription
                    controlledBy
                } 
            }
        }
    `;

    static GET_INVENTORY_PURCHASED_CREDIT_ACCOUNTS = gql`
    query getInventoryPurchasedCreditAccounts{
        getInventoryPurchasedCreditAccounts
    }
    `;

    static GET_ACCOUNTING_DEFAULT_SETTINGS = gql`
    query getAccountingDefaultSettings{ 
        getAccountingDefaultSettings{
        accountsPayable
        purchaseOrderReturnFeesAccount
        defaultBankChecks
        defaultCheckType
        accountingLockDate
        editableCheckNumbers
        postVehicleAccounting
        postROsToAccounting
        requireCheckApprovalPrinting
        vehicleInventoryAccount
        includeROsWithZeroCost
        allowReprintSameCheckNumber
    }}`;
}
